"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var row = function (props) {
    var pageWidth = props.pageWidth, line = props.line, className = props.className, spacing = props.spacing, children = props.children, rest = __rest(props, ["pageWidth", "line", "className", "spacing", "children"]);
    var cn = classnames_1.default(className, {
        emankit__bottom_line: line,
    });
    if (pageWidth) {
        return (react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", __assign({ className: cn }, rest), children)));
    }
    else {
        return (react_1.default.createElement("div", __assign({ className: cn }, rest), children));
    }
};
exports.default = row;
//# sourceMappingURL=index.js.map